<!--  -->
<template>
  <div class="container" v-if="currStudent">
    <div class="info-box">
      <div class="user-box" >
        <div class="user-con" @click="switchChildrenBox">
          <img :src="currStudent.avatarUrl || currStuDefaultHead" alt="" class="user-head">
          <div class="user-name">
            <span class="user-name-text">{{currStudent.name || currStudent.englishName}}</span>
            <i class="iconfont icondengdai0_xiajiantou"></i>
          </div>
        </div>
      </div>
      <h6 class="title">已报课程</h6>
      <ul class="appointment-box">
        <li class="appointment-item" v-for="item in courseStageList" :key="item.courseStage.id">
          <img :src="item.master.headImage" alt="" class="teacher-head">
          <div class="course-info">
            <div class="course">
              <i class="iconfont iconshu"></i>
              <h6 class="course-text">{{item.courseStage.courseStageName}}</h6>
            </div>
            <div class="course">
              <i class="iconfont iconclock"></i>
              <h6 class="course-text">
                {{item.courseStage.weChatScheduleDescription}}
              </h6>
            </div>
          </div>
        </li>
      </ul>
      <div class="children-box" v-if="childrenBoxIsShow">
        <span class="arrow"></span>
        <h6 class="children-box-title">点击头像切换宝贝</h6>
        <ul class="children-con">
          <li class="child-item"
              v-for="child in childrenList"
              :key="child.id"
              :class="{active: child.id === currStudentId}"
              @click="switchStudent(child.id)">
            <img :src="child.avatarUrl || stuDefaultHead" alt="" class="child-head">
            <p class="child-name">{{child.name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="logout-btn" @click="logoutConfirm">退出当前账号</div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import { unbindOpenId } from '@/api/common'
import { getStudentList, getCourseStageList } from '@/api/account'
import gateway from '@/_gateway.config'
import { logout } from '@/utils/_redirect'
let currStuDefaultHead = require('@/assets/img/account/default-head1.png')
let stuDefaultHead = require('@/assets/img/account/default-head2.png')

export default {
  data () {
    return {
      childrenBoxIsShow: false,
      currStuDefaultHead,
      stuDefaultHead,
      childrenList: null,
      currStudentId: '',
      courseStageList: null
    }
  },
  computed: {
    currStudent () {
      if (!this.childrenList) return null
      let s = this.childrenList.filter(c => c.id === this.currStudentId)
      if (s.length) {
        return s[0]
      } else {
        this.switchStudent(this.childrenList[0].id)
        return this.childrenList[0]
      }
    }
  },
  watch: {
    currStudentId () {
      this.getCourseList()
    }
  },
  created () {
    let studentId = +this.$route.query.studentId || +cookie.get('mbstudentid') || null
    this.currStudentId = studentId
    this.getChildrenList()
    this.getCourseList()
    console.log('env', this.$config)
  },
  methods: {
    // 点击头像切换学生显示
    switchChildrenBox () {
      this.childrenBoxIsShow = !this.childrenBoxIsShow
    },
    // 切换学生
    switchStudent (id) {
      if (this.currStudentId === id) return
      this.currStudentId = id
      // this.$setStorage('studentId', id)
      cookie.set('mbstudentid', id, {
        domain: gateway.domain
      })
      this.childrenBoxIsShow = false
    },
    // 退出登录
    logoutConfirm () {
      this.$dialog.confirm({
        title: '退出登录',
        message: '确定要退出当前账号吗？',
        confirmButtonColor: '#65B6F6'
      }).then(() => {
        this.$clearStorage()
        this.logout()
      }).catch(() => {

      })
    },
    logout () {
      const APPID = this.$config.appid
      unbindOpenId({
        openId: cookie.get(`openId_vweixin_${APPID}`),
        userId: cookie.get(`mbparentid`)
      }).then(res => {
        if (res.code === 200) {
          location.href = logout()
          // redirectUri(this.$route.path)
        } else {
          this.$notify({ type: 'warning', message: res.message })
        }
      })
    },
    async getChildrenList () {
      let parentId = cookie.get('mbparentid')
      let res = await getStudentList({ parentId })
      if (res.code === 200) {
        this.childrenList = res.data || []
      } else {
        this.$notify({ type: 'warning', message: res.message })
      }
    },
    async getCourseList () {
      let res = await getCourseStageList({
        studentId: this.currStudentId
      })
      if (res.code === 200) {
        this.courseStageList = res.data
      } else {
        this.$notify({ type: 'warning', message: res.message })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.container {
  background: #F0F0F0;
  .info-box {
    width: 750px;
    height: calc(100vh - 190px);
    margin: 0 auto;
    position: relative;
    padding-top: 60px;
    overflow-y: auto;
  }
  .user-box {
    width: 680px;
    height: 228px;
    margin: 0 auto 35px;
    color: #fff;
    padding-top: 32px;
    background: url("~@/assets/img/account/account-bg.png") no-repeat top left / contain;
    .user-con {
      width: 200px;
      height: 168px;
      // margin: 0 auto;
      margin-left: 50px;
      @include flexBox($direction: column);
      .user-head {
        width: 106px;
        flex: 0 0 106px;
        border-radius: 50% 50%;
        overflow: hidden;
        background: #F0F0F0;
        margin-bottom: 9px;
      }
      .user-name {
        max-width: 220px;
        font-size: 29px;
        font-weight: bold;
        // line-height: 52px;
        padding: 12px 24px;
        border-radius: 30px;
        background: linear-gradient(-30deg,rgba(248,85,22,1),rgba(255,151,50,1));
        position: relative;
        @include flexBox;
        .user-name-text {
          flex-grow: 1;
          @include ellipsis;
        }
        .iconfont {
          font-size: 24px;
          margin-left: 12px;
        }
      }
    }
  }
  .title {
    width: 680px;
    margin: 0 auto;
    font-size: 30px;
    font-weight: bold;
    color: #807D7D;
  }
  .appointment-box {
    margin-top: 32px;
    .appointment-item {
      width: 680px;
      margin: 0 auto 32px;
      border-radius: 20px;
      background: #fff;
      padding: 46px 44px;
      @include flexBox($align: flex-start);
      .teacher-head {
        flex: 0 0 108px;
        width: 108px;
        height: 108px;
        border-radius: 20px;
        background: #F0F0F0;
        margin-right: 38px;
      }
      .course-info {
        flex-grow: 1;
      }
      .course {
        @include flexBox($align: flex-start);
        .iconfont {
          color: #63B1F6;
          margin-right: 10px;
          font-size: 35px;
          margin-top: 2px;
        }
        .course-text {
          color: #333;
          font-size: 30px;
          line-height: 35px;
          font-weight: bold;
        }
      }
      .course ~ .course {
        margin-top: 28px;
      }
    }
  }
  .logout-btn {
    width: 454px;
    // height: 94px;
    padding: 30px 0;
    font-size: 34px;
    color: #65B6F6;
    text-align: center;
    font-weight: bold;
    border:6px solid rgba(97, 172, 245, 1);
    background: #fff;
    border-radius: 60px;
    position: absolute;
    bottom: 64px;
    left: 50%;
    transform: translateX(-50%);
  }
  .children-box {
    width: 685px;
    position: absolute;
    top: 280px;
    left: 33px;
    background: #fff;
    border-radius: 20px;
    padding: 45px 0;
    .children-box-title {
      font-size: 24px;
      color: #333;
      font-weight: bold;
      margin: 0 0 22px 66px;
    }
    .arrow {
      width:0;
      height:0;
      border-width:0 20px 20px;
      border-style:solid;
      border-color:transparent transparent #fff;/*透明 透明  灰*/
      position:relative;
      position: absolute;
      top: -20px;
      left: 115px;
    }
    .children-con {
      width: 100%;
      overflow-x: auto;
      @include flexBox($justify: flex-start);
      flex-wrap: nowrap;
      .child-item {
        flex: 0 0 170px;
        width: 170px;
        margin: 10px 0;
        @include flexBox($direction: column);
        .child-head {
          flex: 0 0 80px;
          width: 80px;
          height: 80px;
          border-radius: 40px;
          background: #f0f0f0;
          margin-bottom: 17px;
        }
        .child-name {
          width: 100%;
          line-height: 120%;
          text-align: center;
          font-size: 24px;
          color: #333;
          font-weight: bold;
          @include ellipsis;
        }
      }
      .active {
        .child-head {
          border: 4px solid #4ea2df;
        }
      }
    }
  }
}
</style>
